import i18n from 'modules/core/lib/i18n'

import DateTimeRangeBlock from '../../../Blocks/DateTimeRange'
import TripBlock from '../../../Blocks/Trip'
import { CustomizationProps } from '../../../withCustomizationFields'
import { PermissionsProps } from '../../../withFieldPermissions'
import FormBlock from '../../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {
  loading: boolean
}

const TripInformation = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.trip_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.trip_information_subtitle')}
    >
      <TripBlock {...props} loading={props.loading} />
      <DateTimeRangeBlock {...props} loading={props.loading} />
    </FormBlock>
  )
}

export default TripInformation
